// Display name for the menu a customer is ordering from.

// Shown in full caps so it reads at a glance, and always ending in the word
// MENU. Names that already end in "menu" keep their own — "Holiday Menu"
// becomes HOLIDAY MENU, not HOLIDAY MENU MENU.
export const formatMenuTitle = name => {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  const upper = trimmed.toUpperCase();
  const lastWord = upper.split(/\s+/).pop();
  return lastWord === 'MENU' ? upper : `${upper} MENU`;
};
